import React, { useCallback } from 'react'
import { MenuDelete, MenuEdit, MenuItem } from '../../../../../../shared/menu/menu'
import { IconImpersonate, IconOrganization } from '../../../../../../shared/icon/icon'
import { useRoleSysLogin } from '../../../../../../role/hook/role-sys'
import { useLoginSysAdmin } from '../../../../../../role/hook/login-sys-admin'

// One login's menu, shared by the Logins grid's row menu and the login
// page's header menu so the two can't drift: the same items, in the same
// order, with the same permissions. The row menu adds Edit first
// ({ edit: true }), which opens the login page, and keeps Organizations
// pinned as an inline icon.
//
// Only system administrators can impersonate (the auth service refuses
// anyone else), so only they are offered it (audit F23).
//
// Returns (loginID, { edit }) => [elements], to pass to <Menu> as children.
export const useLoginMenuItems = () => {
  const roleSysLogin = useRoleSysLogin()
  const isSysAdmin = useLoginSysAdmin()

  return useCallback(
    (loginID, { edit = false } = {}) => {
      const base = `/admin/login/list/edit/${loginID}`
      const list = [
        <MenuItem key="organizations" Icon={IconOrganization} text="organizations" to={`${base}/organizations`} pin={edit || undefined} show={roleSysLogin.accessRead} />,
        <MenuItem key="impersonate-sso" Icon={IconImpersonate} text="sign in as them (SSO)" to={`${base}/impersonate-sso`} show={isSysAdmin} />,
        <MenuDelete key="delete" to={`${base}/delete`} show={roleSysLogin.accessDelete} />
      ]
      return edit ? [<MenuEdit key="edit" to={base} show={roleSysLogin.accessUpdate} />, ...list] : list
    },
    [roleSysLogin, isSysAdmin]
  )
}
